<template>
    <div v-if="vedomosti" class="list_info">
        <div v-if="vedomosti.statement_number" class="item lg:flex items-center">
            <!-- <div class="label">№ {{ $t('vedomosti').toLowerCase() }}:</div> -->
            <div class="label">№:</div>
            <div  class="val">{{ vedomosti.statement_number }}</div>
        </div>
        <div v-if="vedomosti.discipline" class="item lg:flex items-center">
            <div class="label">{{$t('discipline')}}:</div>
            <div v-if="vedomosti.discipline" class="val">{{ vedomosti.discipline.name }}</div>
        </div>
        <div v-if="vedomosti.control_form" class="item lg:flex items-center">
            <div class="label">{{$t('form_of_control')}}:</div>
            <div v-if="vedomosti.control_form"   class="val">{{ vedomosti.control_form.name }}</div>
        </div>
        <div v-if="vedomosti.technology_of_conduct" class="item lg:flex items-center">
            <div class="label">{{$t('technology_of_conduct')}}:</div>
            <div v-if="vedomosti.technology_of_conduct"  class="val">{{ vedomosti.technology_of_conduct.name }}</div>
        </div>
        <div v-if="vedomosti.study_year" class="item lg:flex items-center">
            <div class="label">{{$t('study_year')}}:</div>
            <div v-if="vedomosti.study_year"  class="val">{{vedomosti.study_year.start}}-{{vedomosti.study_year.end}}</div>
        </div>
        <div v-if="vedomosti.acad_period" class="item lg:flex items-center">
            <div class="label">{{$t('acad_periods')}}:</div>
            <div v-if="vedomosti.acad_period" class="val">{{ vedomosti.acad_period.name }}</div>
        </div>
        <div v-if="vedomosti.statement_type" class="item lg:flex items-center">
            <div class="label">{{$t('statement_type')}}:</div>
            <div v-if="vedomosti.statement_type" class="val">{{ vedomosti.statement_type.name }}</div>
        </div>
        <div v-if="vedomosti.type_of_state_certification" class="item lg:flex items-center">
            <div class="label">{{$t('type_of_state_certification')}}:</div>
            <div v-if="vedomosti.type_of_state_certification" class="val">{{ vedomosti.type_of_state_certification.name }}</div>
        </div>
        <div v-if="vedomosti.type_of_statement" class="item lg:flex items-center">
            <div class="label">{{$t('type_of_statement')}}:</div>
            <div v-if="vedomosti.type_of_statement" class="val">{{ vedomosti.type_of_statement.name }}</div>
        </div>
        <div v-if="vedomosti.date" class="item lg:flex items-center">
            <div class="label">{{$t('date')}}:</div>
            <div v-if="vedomosti.date" class="val">{{ date(vedomosti.date) }}</div>
        </div>
        <div v-if="vedomosti.from_time" class="item lg:flex items-center">
            <div class="label">{{$t('from_time')}}:</div>
            <div v-if="vedomosti.from_time" class="val">{{ vedomosti.from_time }}</div>
        </div>
        <div v-if="vedomosti.to_time" class="item lg:flex items-center">
            <div class="label">{{$t('to_time')}}:</div>
            <div v-if="vedomosti.to_time" class="val">{{ vedomosti.to_time }}</div>
        </div>
        <div v-if="vedomosti.group" class="item lg:flex items-center">
            <div class="label">{{$t('eduGroup')}}:</div>
            <div v-if="vedomosti.group" class="val">{{ vedomosti.group.name }}</div>
        </div>
        <div v-if="vedomosti.appraisal_type" class="item lg:flex items-center">
            <div class="label">{{$t('type_of_certification')}}:</div>
            <div v-if="vedomosti.appraisal_type" class="val">{{ vedomosti.appraisal_type.name }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vedomosti:{
            type:Object,
            default: () => {}
        }
    },
    created() {

    },
    methods: {

        date(date) {
            return this.$moment(date).format('DD-MM-YYYY')
        }
    }
}
</script>

<style lang="scss" scoped>
.list_info{
    .item{
        &:not(:last-child){
            margin-bottom: 13px;
            padding-bottom: 13px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .label{
            font-weight: bold;
            padding-right: 10px;
            min-width: 370px;
        }
    }
}
</style>
